import React, { useEffect } from "react";
import "./home.css";
import "./styles/home-journey.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomePremiumSections } from "./components/home/HomePremiumSections";
import { WhatsAppWidget } from "./components/WhatsAppWidget";

const HOME_HASH_TARGETS: Record<string, string> = {
    ecosystem: "ecosystem",
    hero: "hero",
    stats: "business-impact",
    testimonials: "client-trust",
};

const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (!element) return;
    const headerOffset = 100;
    const offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
};

export const Home = () => {
    useEffect(() => {
        const hash = window.location.hash.replace("#", "");
        if (hash === "know-us" || hash === "why-choose-us" || hash === "journey") {
            window.location.replace("/know-us");
            return;
        }
        if (hash && HOME_HASH_TARGETS[hash]) {
            setTimeout(() => scrollToSection(HOME_HASH_TARGETS[hash]), 100);
        }
    }, []);

    return (
        <div className="container journey-page">
            <Header />

            <div className="content">
                <div className="wrapper home-wrapper">
                    <HomePremiumSections />
                    <Footer />
                </div>
            </div>

            <WhatsAppWidget />
        </div>
    );
};
